import styles from '../markers.module.scss';
import { Tooltip } from 'react-leaflet';
import { useTranslation } from 'react-i18next';
import { getObjectIcon, IconColor } from '../icons';
import RotatableMarker from '../rotatable-marker/RotatableMarker';
import { RotationModel } from '../utils';
import { useMemo } from 'react';
import { Icon } from 'leaflet';

export enum ObjectType {
  LO = 'LO',
  RO = 'RO',
}

export interface ObjectMarkerProps extends RotationModel {
  objectType: ObjectType;
  name: string;
}

export function ObjectMarker({ objectType, name, position, heading }: ObjectMarkerProps) {
  const { t } = useTranslation();

  const icon = useMemo<Icon>(() => {
    const iconColor = objectType === ObjectType.LO ? IconColor.Black : IconColor.Blue;
    return getObjectIcon(iconColor, heading);
  }, [objectType, heading]);

  return (
    <RotatableMarker icon={icon} position={position} heading={heading}>
      <Tooltip className="tooltip-override" offset={[30, 0]}>
        <div className={styles.popup}>
          <span>{t(objectType)}</span>
          <span className={styles.popup__name}>{name}</span>
        </div>
      </Tooltip>
    </RotatableMarker>
  );
}

export default ObjectMarker;
